import React, {useState} from 'react';
import {SubmissionDto, SubmissionApi, SubmissionAuditSupervisorResult} from '../../scaffold';
import {Alert, Button, Divider, Popconfirm, Radio, Space} from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import {useInput} from 'react-hanger';
import Title from 'antd/lib/typography/Title';
import {useOpenApiFpRequest} from '../../Http/useOpenApiRequest';
import CommonApiErrorHandler from '../../utils/HttpInstance';
import SubmissionPapers from './Papers';

export default function SubmissionCheckerAudit(props: {submission: SubmissionDto; onSuccess: () => any}) {
  const remark = useInput('');
  const auditState = useOpenApiFpRequest(SubmissionApi, SubmissionApi.prototype.submissionAuditCheckerPost);
  function audit(isPassed: boolean) {
    auditState
      .request({
        submissionAuditCheckerModel: {
          id: props.submission.id || 0,
          isPassed,
          remark: remark.value,
        },
      })
      .then(props.onSuccess)
      .catch(CommonApiErrorHandler);
  }
  return (
    <div>
      <Title level={3}>论文初审</Title>
      <SubmissionPapers submission={props.submission} isJudgeVersion={false} refresh={props.onSuccess} readonly />
      <Title className={'m-t-20'} level={4}>
        备注
      </Title>
      <TextArea {...remark.eventBind} placeholder={'请输入备注'} rows={3} />
      <Space className={'m-t-20'}>
        <Popconfirm title={'确认通过审批吗'} onConfirm={() => audit(true)}>
          <Button type={'primary'} loading={auditState.loading}>
            通过审批
          </Button>
        </Popconfirm>
        <Popconfirm title={'确认退回修改吗'} onConfirm={() => audit(false)}>
          <Button danger loading={auditState.loading}>
            退回修改
          </Button>
        </Popconfirm>
      </Space>
      <Divider />
    </div>
  );
}
